import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { CURRENT_PORTAL } from "constants/app_subdomains";
import { segmentTrack } from "util/segment";

const WHITE_LIST = new Set([
  "query",
  "section",
  "scope",
  "detailedStatuses",
  "transactionTypes",
  "dateConstraint",
  "contacts",
]);

// for our purposes, we characterize any PII(Personally Identifiable Information) as letters.
// this leaves the value open to being a number, represented by a string.
export function sanitizePII(text: string) {
  return text.match(/[A-Za-z]/) ? "[FILTERED]" : text;
}

function sanitizeQueryArgs(queryArgs: URLSearchParams) {
  return new URLSearchParams(
    Array.from(queryArgs.entries())
      .filter(([key]) => WHITE_LIST.has(key))
      .reduce((agg: Record<string, string>, [key, value]) => {
        if (key === "query") {
          agg[key] = sanitizePII(value);
        } else {
          agg[key] = value;
        }
        return agg;
      }, {}),
  );
}

export function useDashboardSegmentTrack() {
  const [searchParams] = useSearchParams();
  const sanitizedQueryString = sanitizeQueryArgs(searchParams);
  const segmentContext = decodeURIComponent(sanitizedQueryString.toString());

  return useCallback(
    (event: string, metaAndOverrides?: null | Record<string, unknown>) => {
      segmentTrack(event, {
        portal: CURRENT_PORTAL,
        context: segmentContext,
        ...metaAndOverrides,
      });
    },
    [searchParams],
  );
}

export function setContainsAllValues<T>(set: Set<T>, values: T[]) {
  if (set.size !== values.length) {
    return false;
  }

  return values.every((value) => set.has(value));
}
